( function ( $, document ) {
	'use strict';

	$( document ).ready( function () {
		$( '.js-read-more-content' ).each( function () {
			const content = $( this );
			const toggle = $( this ).find( '.js-read-more-toggle' );

			$( toggle ).on( 'click', function ( e ) {
				e.preventDefault();

				content.toggleClass( 'is-expanded' );

				if ( $( '.btn__label', this ).text() === 'Read More' ) {
					$( '.btn__label', this ).text( 'Read Less' );
				} else if ( $( '.btn__label', this ).text() === 'Read Less' ) {
					$( '.btn__label', this ).text( 'Read More' );

					// Scroll to keep your position when you close.
					// $([document.documentElement, document.body]).animate({
					//     scrollTop: content.offset().top
					// }, 500);
				}
			});
		});
	});

})(jQuery, document);
